import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export async function loadMetrics(tenantId) {
  const metrics = {};

  // Reuniones y Minutas
  try {
    const meetQ = query(
      collection(db, "meetings"),
      where("tenant_id", "==", tenantId),
    );
    const meetSnap = await getDocs(meetQ);
    const meetings = meetSnap.docs.map((d) => d.data());
    const today = new Date().toISOString().split("T")[0];
    const upcoming = meetings.filter(
      (m) => !m.archived && m.date && m.date >= today,
    ).length;
    const pending = meetings.reduce((sum, m) => {
      const topics = m.agendaTopics || [];
      return (
        sum +
        topics.filter(
          (t) =>
            t.status === "pending" ||
            t.status === "open" ||
            t.status === "in_progress",
        ).length
      );
    }, 0);
    metrics.meetings = {
      line:
        upcoming > 0
          ? `${upcoming} próxima${upcoming !== 1 ? "s" : ""}`
          : "Sin reuniones próximas",
      status: pending > 5 ? "warn" : "ok",
      statusText: pending > 0 ? `${pending} temas pendientes` : "Al día",
    };
  } catch (e) {
    metrics.meetings = { line: "—", status: "ok", statusText: "" };
  }

  // Control Legal
  try {
    const legalQ = query(
      collection(db, "casos"),
      where("tenant_id", "==", tenantId)
    );
    const legalSnap = await getDocs(legalQ);
    const casos = legalSnap.docs.map(d => d.data());
    const activos = casos.filter(c => !c.cerrado && !c.seguimiento && c.estado !== "acordado").length;
    const seguimiento = casos.filter(c => c.seguimiento).length;
    const statusType = seguimiento > 0 ? "warn" : activos > 0 ? "ok" : "ok";
    metrics.legal = {
      line: `${activos} activo${activos !== 1 ? "s" : ""}`,
      status: statusType,
      statusText: seguimiento > 0 ? `${seguimiento} en seguimiento` : "Sin alertas",
    };
  } catch (e) {
    metrics.legal = { line: "—", status: "ok", statusText: "" };
  }

  // Gestión de Cobertura
  try {
    const cauQ = query(
      collection(db, "cauciones_contratos"),
      where("tenant_id", "==", tenantId)
    );
    const cauSnap = await getDocs(cauQ);
    const contratos = cauSnap.docs.map(d => d.data());
    const activos = contratos.filter(c => !c.archived && !c.finalizado).length;
    metrics.cauciones = {
      line: `${activos} contrato${activos !== 1 ? "s" : ""}`,
      status: activos > 0 ? "ok" : "ok",
      statusText: activos > 0 ? "En cobertura" : "Sin contratos",
    };
  } catch (e) {
    metrics.cauciones = { line: "—", status: "ok", statusText: "" };
  }

  // Reserva de Salas — sin tenant isolation, mostramos datos básicos
  metrics.rooms = {
    line: "Consultar disponibilidad",
    status: "ok",
    statusText: "Activa",
  };
  // Higiene y Seguridad
  try {
    const [iperSnap, permisosSnap] = await Promise.all([
      getDocs(query(
        collection(db, "hys_iper"),
        where("tenant_id", "==", tenantId),
        where("estado", "==", "vigente")
      )),
      getDocs(query(
        collection(db, "hys_permisos"),
        where("tenant_id", "==", tenantId),
        where("estado", "==", "activo")
      )),
    ]);
    const ipersVigentes  = iperSnap.size;
    const permisosActivos = permisosSnap.size;
    metrics.hys = {
      line: `${ipersVigentes} IPER vigente${ipersVigentes !== 1 ? "s" : ""}`,
      status: permisosActivos > 0 ? "ok" : "ok",
      statusText: permisosActivos > 0
        ? `${permisosActivos} permiso${permisosActivos !== 1 ? "s" : ""} activo${permisosActivos !== 1 ? "s" : ""}`
        : "Sin permisos activos",
    };
  } catch (e) {
    metrics.hys = { line: "—", status: "ok", statusText: "" };
  }

  return metrics;
}